import { Action as ReduxAction } from 'redux';

import { ReactModalService } from '~commonInfra/dialogs/ReactModalService';
import { Messages } from '~src/codegen/Localize';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { RenameRelayPlanDialogOpts } from '../components/RenameRelayPlanDialog';
import { ContentRelayUtils } from '../utils/ContentRelayUtils';

/**
 * Content Relays → Actions → "Rename" on a single plan. Opens a rename dialog (imperatively, new code
 * avoids Redux/Saga) that updates the plan name via the content-mobility API; returns a no-op action.
 */
export const RenameContentRelayPlanEntityAction: IEntityAction<IContentInfo, {}> = {
  name: EntityActionNames.RenameContentRelayPlan,
  translateName: Messages.rename_action,
  isVisible: (targetItems: IContentInfo[]) =>
    ContentRelayUtils.isContentRelayEnabled() && targetItems.length === 1,
  isClickable: () => true,
  createReduxAction: (targetItems: IContentInfo[]): ReduxAction => {
    const plan = targetItems[0];
    ReactModalService.openCustom(RenameRelayPlanDialogOpts(plan.luid, plan.name));
    return { type: 'contentRelay/renamePlanDialogRequested' };
  },
};
